// extracted by mini-css-extract-plugin
export var authorBioEditorialAbout = "J_cf";
export var authorBioEditorialContainer = "J_cd";
export var authorBioEditorialXp = "J_cg";
export var authorBioPageContainer = "J_cc";
export var relatedArticles = "J_B";